// extracted by mini-css-extract-plugin
export var activeGameSession = "SkrillPrimaryView-module--activeGameSession--11c1f";
export var buttonSkeleton = "SkrillPrimaryView-module--buttonSkeleton--cdd35";
export var depositButton = "SkrillPrimaryView-module--depositButton--3ea44";
export var sectionHeaderSkeleton = "SkrillPrimaryView-module--sectionHeaderSkeleton--f942b";